import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import ScenePOPImg from "@/assets/report-assets/scene-pop-tooltip.png";

/*
 * POPInfoModal component
 *
 * This modal displays information about the Probability of Perception (POP) metric.
 */
export const POPInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>POP (Probability of Preception)</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Image */}
      <div className="flex items-center justify-center">
        <img src={ScenePOPImg} alt="POP visualization" className="w-[261px] rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">Probability of Perception shows percentage of viewers likely to notice the element at first glance</p>
    </div>
  );
};
